<template>
  <div>
    <div class="flex mb-4" style="align-items: center;">
      <h5>일일안전점검표</h5>
      <vs-spacer></vs-spacer>
    </div>
    <div style="margin-left:-1.2rem; margin-right:-1.2rem; padding:1.2rem; background: #fff;">
      <div class="flex mb-8" style="justify-content: flex-end;">
        <vs-button class="w-1/2 mr-2" color="secondary" type="border" @click="back">목록</vs-button>
      </div>

      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>기본정보</h5></vs-col>
      </vs-row>

      <vs-row class="mb-4 flex flex-wrap" >

        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">사무소명</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.project_title" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title pr-4 ">차수</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.orderNumber" :readonly="true"></vs-input></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">대상기간</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.date" :readonly="true"/></vs-col>
        </vs-row>
      </vs-row>

      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>중점 점검항목 - A등급</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8">
        <vs-col class="border" style="overflow-x: auto;">
          <ul class="table table-8">
            <li style="display: flex">
              <p style="min-width:60px;">No.</p>
              <p style="min-width:150px;">소속</p>
              <p style="min-width:150px;">대상공종</p>
              <p style="min-width:150px;">위치/장소</p>
              <p style="min-width:150px;">위험요인</p>
              <p style="min-width:150px;">재해형태</p>
              <p style="min-width:150px;">안전보건대책</p>
              <p style="min-width:150px;">점검결과 조치사항</p>
            </li>
            <li class="tbody" style="display: flex" v-for="(item, index) in form.list1" :key="index">
              <p class="p-2" style="min-width:60px;">{{index}}</p>
              <p class="p-2" style="min-width:150px;">파트너사 </p>
              <p class="p-2" style="min-width:150px;">대상공종 {{item.work_unit}}  </p>
              <p class="p-2" style="min-width:150px;">위치/장소 </p>
              <p class="p-2" style="min-width:150px;">{{item.risk_factor}}</p>
              <p class="p-2" style="min-width:150px;">{{item.disaster_type}}</p>
              <p class="p-2" style="min-width:150px;">{{item.safety_measures}}</p>
              <p class="p-2" style="min-width:150px;"></p>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MobileSafetyDailyCheckDetail',
  data () {
    return {
      form:{
        project_title:'', //사무소명
        orderNumber:'', //차수
        company:'', //파트너사
        date:'', //대상기간
        list1:[], //중점관리 위험요인
        list2:[] //일상 위험관리
      }
    }
  },
  created () {
    this.loadPostDetail()
  },

  methods:{
    async loadPostDetail () {

      // 내용불러오기
      const projectId = this.$route.params.proj_id
      const boardId = 12 //일일안전점검표
      const postId = this.$route.params.postId

      await this.$store.dispatch('board/LOAD_POST', {projectId, boardId, postId})
      const postInfo = this.$store.state.board.postInfo
      const post = JSON.parse(postInfo.post_content)

      this.form.project_title = postInfo.project.field_name
      this.form.orderNumber = postInfo.project_order.order_number
      this.form.company = post.company
      this.form.date = post.date
      this.form.list1 = post.list1
      this.form.list2 = post.list2
    },

    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.bc-grade li:nth-child(2n+1) {
  background: #fafafa;
}
</style>

<style scoped>
.vs-row .border {
  border-left:none;
  border-right:none;
}
ul.table.table-title-2 > li { grid-template-columns: 1fr 2fr 2fr;}
ul.table > li > p { height:100%; display:flex; align-items: center; justify-content: center; padding:6px; font-weight: 500; }
ul.table > li.tbody > p { font-weight: normal; }
</style>
